import type { CustomFieldDTO } from '@tempo-io/item-store-dto';
import { PublishedCustomFieldValue } from './PublishedCustomFieldValue';
import type { ItemDetails } from './types';

interface PublishedCustomFieldsProps {
  itemDetails: ItemDetails;
  customFieldDefinitions: CustomFieldDTO[];
}

export const PublishedCustomFields = ({
  itemDetails,
  customFieldDefinitions,
}: PublishedCustomFieldsProps) => {
  const visibleFields = customFieldDefinitions
    .filter((field) => field.archivedAt === undefined)
    .sort((a, b) => a.priority.localeCompare(b.priority, 'en-US'));

  if (visibleFields.length === 0) {
    return (
      <output className="flex items-center justify-center h-full text-text-neutral-secondary">
        No custom fields
      </output>
    );
  }

  return (
    <dl className="flex flex-col gap-4">
      {visibleFields.map((field) => {
        const fieldId = field.id.toString();
        const value = itemDetails.customFields?.[fieldId];

        return <PublishedCustomFieldValue key={fieldId} field={field} value={value} />;
      })}
    </dl>
  );
};
